export const STATUS: Record<string, string> = {
  ACTIVE: 'true',
  INACTIVE: 'false',
};
